/* eslint-disable */
export const COORDINATES = 'coordinates';

export const DOCUMENT_DETAILS = 'DOCUMENTS_DETAILS';

export const DOCUMENT_STATUS = {
  COLLECTION_SKIPPED: 'COLLECTION_SKIPPED',
  RECEIVED: 'RECEIVED',
  PENDING: 'PENDING',
  RECOLLECTION_PENDING: 'RECOLLECTION_PENDING',
};

export const reasons = ["Customer Denied", "Other"];

export const UPLOADED_DOCUMENTS="UPLOADED_DOCUMENTS";
